import type { FC } from 'react'

import { Swipeable } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'

import useUser from '@/hooks/user'

import { Translation } from '../i18n/Translation'

import Addons from './Addons'
import type { Order, Inventory } from './types'

import './style/addons.scss'

const Order3Addons: FC<{
  order: Order
  models: Record<string, Inventory>
  isVisible: boolean
  cancelOrder: () => void
  confirmAddons: () => void
  removeAddon: (productId: number) => void
  addAddon: (productId: number) => void
}> = ({ order, models, isVisible, cancelOrder, confirmAddons, removeAddon, addAddon }) => {
  const user = useUser()

  return (
    <Swipeable
      id="order-addons"
      className={isVisible ? 'is-visible' : 'is-hidden'}
      onSwipedLeft={cancelOrder}
    >
      <div className="header">
        <Translation id="Tilleggsutstyr" />
      </div>

      <div className="addons-helper">
        {user?.customerId === 1000435 ? ( // Kongsberg Satellite Services
          <Translation id="Alle telefoner blir levert med beskyttelsesglass og bakdeksel. Ønsker du wallet i stedet for bakdeksel kan du velge dette under bestilling." />
        ) : (
          <Translation id="Tilleggsutstyr som ikke er på lager som billader, deksel eller beskyttelsesglass kan bestille senere under valget Tilleggsutstyr." />
        )}
      </div>

      <div className="addons">
        <Addons inventory={models} order={order} removeAddon={removeAddon} addAddon={addAddon} />
      </div>

      <div className="buttons">
        <Button variant="tertiary" onClick={cancelOrder}>
          <Translation id="Avbryt" />
        </Button>

        <Button variant="primary" onClick={confirmAddons}>
          <Translation id="Bekreft" />
        </Button>
      </div>
    </Swipeable>
  )
}

export default Order3Addons
